// extracted by mini-css-extract-plugin
export default {"PageContainer":"AuthPage_PageContainer__pyS5k"};